export const TOTAL_STEPS = 6;

export const STEP_TITLES = Object.freeze({
  1: 'Choose Location',
  2: 'Choose Era',
  3: 'Name Your Place',
  4: 'Add Story and Files',
  5: 'Additional Information',
  6: 'Looks good?',
});

export const STEP_SUBTITLES = Object.freeze({
  1: 'Type an address, or click directly on the map.',
  2: 'Enter the year, or your best estimate.',
  3: 'What was it called then, or how do you remember it?',
  4:
    'What do you remember? Add as much or as little as you like. (At least one story and/or file is required.)',
  5: '',
  6: 'Review your entry, then choose who can see it.',
});

export const WIZARD_ACTIONS = Object.freeze({
  SET_ADDRESS: 'SET_ADDRESS',
  SET_LATLNG: 'SET_LATLNG',
  SET_SHAPE_TYPE: 'SET_SHAPE_TYPE',
  SET_POLYGON_COORDINATES: 'SET_POLYGON_COORDINATES',
  SET_LINE_COORDINATES: 'SET_LINE_COORDINATES',
  SET_YEAR: 'SET_YEAR',
  SET_PLACE_NAME: 'SET_PLACE_NAME',
  SET_CAPTION: 'SET_CAPTION',
  SET_STORY_TEXT: 'SET_STORY_TEXT',
  SET_FILES: 'SET_FILES',
  SET_ADDITIONAL_FIELD: 'SET_ADDITIONAL_FIELD',
  SET_VISIBILITY: 'SET_VISIBILITY',
  SET_TAXONOMY_IDS: 'SET_TAXONOMY_IDS',
  TOGGLE_TAXONOMY_ID: 'TOGGLE_TAXONOMY_ID',
  // PR #45 — v2 ranked themes. Themes carry an explicit rank
  // (1=Primary, 2=Secondary, 3=Tertiary). Client July 2026 (#7) extended
  // the same ranked model to Property Type and Communities, so all three
  // kinds now dispatch SET/CLEAR_*_AT_RANK. The single-select
  // SET_PROPERTY_TYPE_ID / SET_COMMUNITY_ID actions are retained for
  // back-compat with any un-migrated caller.
  SET_THEME_AT_RANK: 'SET_THEME_AT_RANK',
  CLEAR_THEME_AT_RANK: 'CLEAR_THEME_AT_RANK',
  SET_PROPERTY_TYPE_AT_RANK: 'SET_PROPERTY_TYPE_AT_RANK',
  CLEAR_PROPERTY_TYPE_AT_RANK: 'CLEAR_PROPERTY_TYPE_AT_RANK',
  SET_COMMUNITY_AT_RANK: 'SET_COMMUNITY_AT_RANK',
  CLEAR_COMMUNITY_AT_RANK: 'CLEAR_COMMUNITY_AT_RANK',
  SET_PROPERTY_TYPE_ID: 'SET_PROPERTY_TYPE_ID',
  SET_COMMUNITY_ID: 'SET_COMMUNITY_ID',
  SET_FORM_ID: 'SET_FORM_ID',
  SET_FORM_FIELDS: 'SET_FORM_FIELDS',
  SET_CONT_FIRST_NAME: 'SET_CONT_FIRST_NAME',
  SET_CONT_LAST_NAME: 'SET_CONT_LAST_NAME',
  SET_CONT_EMAIL: 'SET_CONT_EMAIL',
  RESET: 'RESET',
});
